import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-footer',
    imports: [RouterLink],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.sass'
})
export class FooterComponent {
    readonly year = new Date().getFullYear();
    readonly siteOwnerName = environment.siteOwnerName;
    readonly linkedInProfileUrl = environment.linkedInProfileUrl;
}
